import { QuotationTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1601. 見積タスクコメントリアクションtoggle
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/quotation_task_comments/:id/reactions
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
  emoji_id: string;
  content: string;
};

const quotationTaskCommentReaction = (props: Props): Promise<QuotationTaskComment> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/quotation_task_comments/${props.id}/reactions`,
    props
  );
};

export const useQuotationTaskCommentReaction = () => {
  return useMutation({
    mutationFn: quotationTaskCommentReaction,
  });
};
